import React from 'react';
import { _ } from '_locales';
import styled from 'styled-components';

import HOC from '_HOC';
import { goToTop } from '_helpers';
import { LeftArrow } from './Images';
import store from '../configureStore';

const Container = styled.div`
    height: 63px;
    background-color: #fff !important;
`;

const BackButtonContainer = styled.div`
    float: left;
    margin: 29px 0 0 18px;
    box-sizing: border-box;
    position: absolute;
`;

const BackKey = styled.button`
  all: initial;
  font-family: Roboto, sans-serif !important;
  margin: 2px;
  display: flex; 
  background: none;
  border: none;
  outline: none;

  height: 30px;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

const InnerBackKey = styled.span`
  padding: 4px 11px;
  box-sizing: border-box;
  cursor: pointer;
  flex: 1;
  position: relative;
   
  font-size: 18px !important;

  ${BackKey}:focus > & {
    box-shadow: 0 0 2px 2px #51a7e8;
    border-radius: 5px;
  }

  &:focus {
    outline: none;
  }
`;

/**
 * Webapp SubHeader: go to the previous route by clicking on back button
 * It doesn't appear from these routes: ['/wgw', '/cal', '/zone-setup/list',
 * '/zone-setup/map', '/zone-setup/search']
 *
 * @author Alireza Zebardast
 * @param {Object} props
 *
 */
const WebappSubHeader = ({ zone, config, props }) => {
  const { zoneStr } = zone;
  const { history, location } = props;
  const { shouldSeeDistrictSelector, isMultiDistrict, webappConfig } = config;
  const {
    set_rap_landing_page, has_news = false,
    has_wgw = false,
    has_calendar = false,
    has_dz = false,
    has_bulk_pickup = false
  } = webappConfig;

  const isSingleTab = (has_calendar + has_wgw + has_dz + has_bulk_pickup) === 1;

  const state = store.store.getState();
  const { isCampaignActive } = state.campaign;

  let hasNotSubHeader = ['/wgw', '/cal', '/resources', '/education', '/bulk-pickup'];
  const multiDisHasNotSubHeader = ['/select-districts'];
  const singleDisHasNotSubHeader = ['/zone-setup/list', '/zone-setup/map', '/zone-setup/search'];

  hasNotSubHeader = (!zoneStr) ? hasNotSubHeader.concat(multiDisHasNotSubHeader) : hasNotSubHeader;
  hasNotSubHeader = (
    !zoneStr
    && !shouldSeeDistrictSelector
  ) ? hasNotSubHeader.concat(singleDisHasNotSubHeader) : hasNotSubHeader;

  const hasBackButton = !!(hasNotSubHeader.find(
    (item) => location.pathname === item
      || (location.pathname.includes('/help'))
  )
  );

  const backFunc = () => {
    goToTop();
    if (
      isMultiDistrict
      && !zoneStr
      && location.pathname.includes('/zone-setup')
      && !location.pathname.includes('/confirm-zone')
    ) {
      history.push('/select-districts');
      return;
    }
    // if there is only one event
    if (location.state?.normaList?.length === 1) {
      history.go(-2);
      return;
    }
    if (location.pathname.includes('/help')) {
      history.push('/help');
      return;
    }
    history.goBack();
  };

  return (
    <>
      {
        (!!(
          history.length > 1
          && !hasBackButton
          && !isCampaignActive
        ) || (location.pathname.includes('help/')))
        && (
          <Container>
            <BackButtonContainer>
              <BackKey tabIndex="0" onClick={backFunc} aria-label="back to the previous page">
                <LeftArrow />
                <InnerBackKey tabIndex="-1">{_('general.back')}</InnerBackKey>
              </BackKey>
            </BackButtonContainer>
          </Container>
        )
      }
    </>
  );
};

export default HOC(WebappSubHeader);
